import _ from 'lodash';
import React, { Component } from 'react';
import styles from './ResizeKnobsStyles';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import { setIsResizingElement, setDraggingDirection } from 'crazyEditor/redux/modules/stage/stage';

@connect(
  false,
  {
    setIsResizingElement,
    setDraggingDirection
  }
)
@Radium
export default class ResizeKnobs extends Component {
  constructor(props) {
    super(props);

    this.onMouseDown = this.onMouseDown.bind(this);
  }

  onMouseDown(direction, event) {
    const { setIsResizingElement, setDraggingDirection } = this.props;
    setDraggingDirection(direction, {x: event.pageX, y: event.pageY});
    event.stopPropagation();
  }

  render() {
    const { knobs } = this.props;
    return (
      <span>
        {_.map(knobs, (knobDirection) =>
          (<span draggable={false} key={knobDirection} style={[styles.knob, styles[knobDirection]]}
                 data-resize-knob={knobDirection}
                 onMouseDown={this.onMouseDown.bind(this, knobDirection)}/>))
        }
      </span>
    );
  }
}

ResizeKnobs.propTypes = {
  knobs: PropTypes.array.isRequired
};